import React from 'react'
import { Link } from 'react-router-dom'

import { Typography } from '@mui/material'

import { SeoArticleLayout } from './SeoArticleLayout'

const body = (chunks: React.ReactNode[]) =>
  chunks.map((el, i) => (
    <Typography
      key={i}
      variant={i === 0 ? 'body1' : 'body2'}
      sx={{
        mt: i === 0 ? 0 : 2.75,
        lineHeight: 1.82,
        fontSize: i === 0 ? { xs: '1.05rem', md: '1.08rem' } : '0.9375rem',
        color: i === 0 ? 'text.primary' : 'rgba(0, 0, 0, 0.72)',
        letterSpacing: i === 0 ? '0.01em' : '0.005em'
      }}
    >
      {el}
    </Typography>
  ))

export const KomplektuyuchiVentylyatsiyiKondytsionuvannyaPage: React.FC = () => (
  <SeoArticleLayout
    seoTitle='Комплектуючі для вентиляції та кондиціонування повітря'
    seoDescription={[
      'Купити комплектуючі для систем вентиляції та кондиціонування повітря в Україні:',
      'решітки, дифузори, фасонні вироби. VentBudEngineering — виробництво та доставка.'
    ].join(' ')}
    canonicalPath='/komplektuyuchi-ventylyatsiyi-kondytsionuvannya'
    h1='Комплектуючі для систем вентиляції та кондиціонування повітря'
    relatedLinks={[
      { to: '/catalog/grid', label: 'Каталог: вентиляційні решітки та дифузори' },
      { to: '/catalog/ventAccessories', label: 'Каталог: комплектуючі вентиляції' },
      { to: '/about/airDucts', label: 'Повітропроводи для вентиляційних мереж' },
      { to: '/contact-us', label: 'Контакти та офіс у Києві' }
    ]}
  >
    {body([
      <>
        VentBudEngineering спеціалізується на виготовленні{' '}
        <strong>комплектуючих для систем вентиляції та кондиціонування повітря</strong>: від
        декоративних і технічних решіток до елементів повітроводів і супутніх виробів для монтажу
        інженерних мереж.
      </>,
      <>
        Правильно підібрані комплектуючі забезпечують герметичність вузлів, рівномірний розподіл
        повітря, зниження шуму та зручне обслуговування обладнання. Ми працюємо з замовниками з
        Києва та інших міст України — допомагаємо підібрати типорозміри під ваш проєкт.
      </>,
      <>
        Переглянути асортимент можна в каталозі:{' '}
        <Link to='/catalog/grid'>вентиляційні решітки та дифузори</Link>,{' '}
        <Link to='/catalog/ventAccessories'>комплектуючі вентиляції</Link> (клапани, адаптери,
        шумоглушники тощо). Для повітроводів прямокутного та круглого перерізу — розділ{' '}
        <Link to='/about/airDucts'>про повітропроводи</Link>.
      </>,
      <>
        Потрібна консультація чи комерційна пропозиція? Звʼяжіться з нами через сторінку{' '}
        <Link to='/contact-us'>контактів</Link> або зателефонуйте — підкажемо по наявності та
        термінах виготовлення.
      </>
    ])}
  </SeoArticleLayout>
)

export const ReshitkyTaDyfuzzoryPage: React.FC = () => (
  <SeoArticleLayout
    seoTitle='Вентиляційні решітки та дифузори'
    seoDescription={[
      'Вентиляційні решітки та дифузори від виробника: прямокутні, квадратні, лінійні, зовнішні.',
      'Моделі та ціни в каталозі VentBudEngineering.'
    ].join(' ')}
    canonicalPath='/reshitky-ta-dyfuzzory'
    h1='Вентиляційні решітки та дифузори'
    relatedLinks={[
      { to: '/catalog/grid', label: 'Каталог решіток і дифузорів' },
      {
        to: '/komplektuyuchi-ventylyatsiyi-kondytsionuvannya',
        label: 'Комплектуючі для вентиляції та кондиціонування'
      },
      { to: '/services', label: 'Монтаж вентиляції та інженерні послуги' }
    ]}
  >
    {body([
      <>
        <strong>Вентиляційні решітки та дифузори</strong> — видимий і функціональний елемент
        системи: вони регулюють напрямок і інтенсивність потоку, узгоджуються з інтерʼєром і
        захищають канали від пилу. У каталозі представлені одно- та дворядні прямокутні решітки,
        квадратні дифузори, лінійні моделі, зовнішні решітки та інші типи.
      </>,
      <>
        Підбір залежить від площі приміщення, витрати повітря, рівня акустичних вимог і способу
        монтажу (стеля, стіна, підлога). Якщо ви не впевнені у моделі — напишіть нам параметри
        обʼєкта, і ми запропонуємо варіанти з каталогу.
      </>,
      <>
        Усі актуальні серії та зображення — у розділі{' '}
        <Link to='/catalog/grid'>«Решітки та дифузори»</Link>. Також доступні{' '}
        <Link to='/catalog/ventAccessories'>комплектуючі вентиляції</Link> для стиків і перехідних
        вузлів.
      </>
    ])}
  </SeoArticleLayout>
)

export const PovitroprovodyVentylyatsiyaPage: React.FC = () => (
  <SeoArticleLayout
    seoTitle='Повітропроводи для вентиляції'
    seoDescription={[
      'Повітропроводи прямокутного та круглого перерізу для вентиляції та кондиціонування:',
      'призначення, типи, фасонні елементи та стик з решітками. VentBudEngineering, Київ.'
    ].join(' ')}
    canonicalPath='/povitroprovody-ventylyatsiya'
    h1='Повітропроводи для систем вентиляції'
    relatedLinks={[
      { to: '/about/airDucts', label: 'Детальніше про повітропроводи' },
      { to: '/catalog/grid', label: 'Решітки та дифузори до повітроводів' },
      { to: '/komplektuyuchi-ventylyatsiyi-kuputy-kyyiv', label: 'Де купити комплектуючі в Києві' }
    ]}
  >
    {body([
      <>
        <strong>Повітропроводи</strong> транспортують повітря між вентиляційною установкою,
        обігрівачами, кондиціонерами та решітками. Прямокутні канали часто обирають через економію
        висоти перекриття; круглі — через зручність магістралей і типові розміри фітингів.
      </>,
      <>
        Якісне стикування з <Link to='/catalog/grid'>решітками та дифузорами</Link>, герметичність
        фланців і правильні переходи зменшують втрати тиску та шум у мережі. На сторінці{' '}
        <Link to='/about/airDucts'>«Повітропроводи»</Link> ми описуємо застосування прямокутних і
        круглих систем і фасонних виробів.
      </>,
      <>
        Комплексно підібрати вузли для вашого обʼєкта допоможуть наші фахівці — звертайтесь через{' '}
        <Link to='/contact-us'>контакти</Link>.
      </>
    ])}
  </SeoArticleLayout>
)

export const KomplektuyuchiKuputyKyyivPage: React.FC = () => (
  <SeoArticleLayout
    seoTitle='Комплектуючі для вентиляції купити Київ'
    seoDescription='Купити комплектуючі для вентиляції в Києві: решітки, дифузори, клапани, адаптери. Офіс на Дубровицькій, 28. Доставка по Україні. VentBudEngineering.'
    canonicalPath='/komplektuyuchi-ventylyatsiyi-kuputy-kyyiv'
    h1='Комплектуючі для вентиляції купити в Києві'
    relatedLinks={[
      { to: '/catalog/grid', label: 'Каталог решіток і дифузорів' },
      { to: '/catalog/ventAccessories', label: 'Каталог комплектуючих вентиляції' },
      { to: '/contact-us', label: 'Адреса офісу та телефони' }
    ]}
  >
    {body([
      <>
        Шукаєте, де <strong>купити комплектуючі для вентиляції в Києві</strong>? VentBudEngineering
        виготовляє продукцію під типові та індивідуальні розміри; офіс та прийом замовлень — за
        адресою вулиця Дубровицька, 28 (деталі на сторінці <Link to='/contact-us'>контактів</Link>
        ).
      </>,
      <>
        У каталозі онлайн можна переглянути моделі решіток і дифузорів, шумоглушників, клапанів,
        гнучких вставок та інших позицій. За потреби узгодимо постачання та умови відвантаження по
        Україні.
      </>,
      <>
        Перейти до товарів: <Link to='/catalog/grid'>решітки та дифузори</Link>,{' '}
        <Link to='/catalog/ventAccessories'>комплектуючі вентиляції</Link>.
      </>
    ])}
  </SeoArticleLayout>
)

export const MontazhTaServisVentylyatsiyiPage: React.FC = () => (
  <SeoArticleLayout
    seoTitle='Монтаж та сервіс систем вентиляції'
    seoDescription='Монтаж вентиляції, кондиціонування, опалення та інженерних мереж у Києві та Україні. Перелік послуг VentBudEngineering.'
    canonicalPath='/montazh-ta-servis-ventylyatsiyi'
    h1='Монтаж та обслуговування вентиляційних систем'
    relatedLinks={[
      { to: '/services', label: 'Повний перелік послуг' },
      { to: '/komplektuyuchi-ventylyatsiyi-kondytsionuvannya', label: 'Комплектуючі для вентиляції' },
      { to: '/contact-us', label: 'Звʼязатися з нами' }
    ]}
  >
    {body([
      <>
        Окрім виробництва комплектуючих, команда VentBudEngineering надає{' '}
        <strong>інженерні та монтажні послуги</strong>: вентиляція та кондиціонування повітря,
        тепло- та холодопостачання, водопровід і каналізація, опалення, монтаж димохідних систем,
        автоматизація вентустановок.
      </>,
      <>
        Комплексний підхід дозволяє узгодити підбір <Link to='/catalog/grid'>обладнання</Link> з
        реальними умовами обʼєкта та вимогами до енергоефективності й шуму.
      </>,
      <>
        Детальний опис напрямів — на сторінці <Link to='/services'>«Послуги»</Link>. Для розрахунку
        та виїзду звертайтесь через <Link to='/contact-us'>контакти</Link>.
      </>
    ])}
  </SeoArticleLayout>
)
